class GatedPost {
	sessionKey = 'submitted-gated-forms';

	constructor(el) {
		this.mainContent = el;
		this.gatedForm = el.querySelector('.gated-post__container');
		this.postContent = el.querySelector('.tmpl-post-single');
		this.gatedFormId = this.gatedForm.getAttribute('data-gatedFormId');

		if (this.gatedForm && this.isGatedFormFilled() === false) {
			this.init();
		} else {
			this.cleanPopUpForm();
		}
	}

	isGatedFormFilled(gatedFormId) {
		const session = this.getSessionData();

		return session.formIds.includes(this.gatedFormId);
	}

	getSessionData() {
		const defaultData = { formIds: [] };
		let sessionData = sessionStorage.getItem(this.sessionKey);

		if (!sessionData) {
			this.setSessionData(defaultData);
			sessionData = defaultData;
		} else {
			sessionData = JSON.parse(sessionData);
		}

		return sessionData;
	}

	setSessionData(data) {
		sessionStorage.setItem(this.sessionKey, JSON.stringify(data));
	}

	updateSavedForms() {
		const session = this.getSessionData();
		session.formIds.push(this.gatedFormId);
		this.setSessionData(session);
	}

	init() {
		const form = this.gatedForm.querySelector('form');

		if (form) {
			const observer = new MutationObserver((mutations, obs) => {

				const confirmationMessage = mutations.flatMap((mutationRecord) => {
					if (mutationRecord.type === 'childList') {
						return Array.from(mutationRecord.addedNodes);
					}
				}).find(node => node.classList?.contains('gform_confirmation_wrapper'));


				if (confirmationMessage) {
					this.cleanPopUpForm();
					this.updateSavedForms();
					obs.disconnect();
				}
			});

			observer.observe(this.gatedForm, {
				childList: true,           // watch for addition/removal of child nodes
				subtree: true,           // watch all levels down from `form`
				characterData: true
			});

		}
	}

	cleanPopUpForm() {
		this.mainContent.classList.remove('gated-post__underlying-content--container');
		this.gatedForm.style.display = 'none';
		this.postContent.classList.remove('gated-post__underlying-content');
	}
}

export default GatedPost;
